import { Col, ControlLabel, Glyphicon } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Button from 'components/button/Button';
import { FormGroupContainer } from 'components/forms/genericFormField/GenericFormField.styles';
import Tooltip from 'components/tooltip/Tooltip';
import { WebsiteSettingsModalPath } from '../../../DirectBookingEngineTabs.constants';
import { BrandColorsRowStyled } from './ColorSettings.styles';

const BrandColorsField = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <FormGroupContainer $name="brandColors">
      <Col
        componentClass={ControlLabel}
        data-testid="brandColors-field-label"
        sm={5}
        xs={4}
      >
        {t('pageDirectBookingEngine.websiteSettings.brandColors')}
      </Col>
      <Col sm={7} xs={8}>
        <BrandColorsRowStyled>
          <Button
            bsStyle="link"
            data-testid="add-color-settings-button"
            onClick={() => navigate(WebsiteSettingsModalPath.colors)}
          >
            {t('pageDirectBookingEngine.websiteSettings.addColorSettings')}
          </Button>
          <Tooltip
            id="brandColors-tooltip"
            text={t(
              'pageDirectBookingEngine.websiteSettings.brandColorsTooltip',
            )}
          >
            <Glyphicon
              data-testid="brandColors-tooltip-icon"
              glyph="info-sign"
            />
          </Tooltip>
        </BrandColorsRowStyled>
      </Col>
    </FormGroupContainer>
  );
};

export default BrandColorsField;
